import request from '../../libs/request';

export default {
  personalized: (id, siteId) => {
    return request(`api/v1/${siteId}/pagina/publications/desktop/landingPageProduct/${id}`).get();
  },

  recommendations: (queryParams, siteId, token) => {
    return request(`${siteId}/pdg`, 'ocean').get({ queryParams, token });
  },

  getProduct: (siteId, id, idSeller, token) =>
    request(`${siteId}/produto/${id}/catalogo`, 'ocean').get({
      queryParams: { idSeller, placementType: 'ITEM_PAGE' },
      token,
    }),

  sendSpecialistContact: (body, siteId) => {
    return request(`api/v1/${siteId}/contato/produtos`).post({ body });
  },
};
